<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header
                class="d-flex justify-content-between align-items-center"
            >
                <h5 class="modal-title">Manajemen Kategori Pengeluaran</h5>
                <div>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="addKategori"
                    >
                        <i class="fas fa-plus-square"></i> Tambah Kategori
                    </button>
                </div>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th style="width: 50px" class="text-center">
                                    #
                                </th>
                                <th>Nama Kategori</th>
                                <th style="width: 150px" class="text-center">
                                    Aksi
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading">
                            <tr>
                                <td colspan="3" class="text-center">
                                    Loading...
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="kategoriList.length === 0">
                            <tr>
                                <td colspan="3" class="text-center">
                                    Tidak ada data
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr
                                v-for="(kategori, index) in kategoriList"
                                :key="kategori.id"
                            >
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>{{ kategori.name }}</td>
                                <td class="text-center">
                                    <button
                                        type="button"
                                        title="Edit"
                                        @click="editKategori(kategori)"
                                        class="btn btn-link px-1"
                                    >
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    <button
                                        type="button"
                                        title="Delete"
                                        @click="deleteKategori(kategori)"
                                        class="btn btn-link px-1 text-danger"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button
                    @click="$emit('cancel')"
                    type="button"
                    class="btn btn-secondary"
                >
                    Tutup
                </button>
            </b-card-footer>
        </b-card>

        <b-modal
            v-model="formModal"
            :title="currentKategori ? 'Edit Kategori' : 'Tambah Kategori'"
            @hidden="resetForm"
            header-bg-variant="primary"
            header-text-variant="white"
            hide-footer
        >
            <div>
                <div class="form-group">
                    <label>Nama Kategori</label>
                    <input
                        v-model="form.name"
                        type="text"
                        class="form-control"
                        placeholder="Masukkan nama kategori"
                        v-validate="'required'"
                        name="name"
                    />
                    <span class="text-danger">{{ errors.first("name") }}</span>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        type="button"
                        class="btn btn-secondary mr-2"
                        @click="formModal = false"
                    >
                        Batal
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="saveKategori"
                        :disabled="isLoading"
                    >
                        Simpan
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "kategori-pengeluaran-manager",

    data() {
        return {
            isLoading: false,
            kategoriList: [],
            formModal: false,
            currentKategori: null,
            form: {
                name: "",
            },
        };
    },

    created() {
        this.loadKategori();
    },

    methods: {
        loadKategori() {
            let self = this;
            self.isLoading = true;

            axios
                .get("/api/kategori-pengeluarans")
                .then(function (response) {
                    self.kategoriList = response.data.data;
                    self.isLoading = false;
                })
                .catch(function (error) {
                    self.requestFailed(error);
                    self.isLoading = false;
                });
        },

        addKategori() {
            this.currentKategori = null;
            this.form.name = "";
            this.formModal = true;
        },

        editKategori(kategori) {
            this.currentKategori = Object.assign({}, kategori);
            this.form.name = kategori.name;
            this.formModal = true;
        },

        resetForm() {
            this.form.name = "";
            this.currentKategori = null;
        },

        saveKategori() {
            let self = this;

            self.$validator.validateAll().then((result) => {
                if (result) {
                    self.isLoading = true;

                    let method = self.currentKategori ? "put" : "post";
                    let url = self.currentKategori
                        ? `/api/kategori-pengeluarans/${self.currentKategori.id}`
                        : "/api/kategori-pengeluarans";

                    axios({
                        method: method,
                        url: url,
                        data: {
                            name: self.form.name,
                        },
                    })
                        .then(function (response) {
                            Toast.fire({
                                icon: "success",
                                title:
                                    response.data.message ||
                                    "Kategori berhasil disimpan",
                            });
                            self.loadKategori();
                            self.formModal = false;
                            self.isLoading = false;
                        })
                        .catch(function (error) {
                            self.requestFailed(error);
                            self.isLoading = false;
                        });
                }
            });
        },

        deleteKategori(kategori) {
            let self = this;

            Swal.fire({
                title: "Apakah anda yakin?",
                text: "Jika kategori dihapus, semua kas kecil dengan kategori ini akan menjadi tanpa kategori!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Ya, hapus!",
                cancelButtonText: "Batal",
            }).then((result) => {
                if (result.value) {
                    self.isLoading = true;

                    axios({
                        method: "delete",
                        url: `/api/kategori-pengeluarans/${kategori.id}`,
                    })
                        .then(function (response) {
                            Toast.fire({
                                icon: "success",
                                title:
                                    response.data.message ||
                                    "Kategori berhasil dihapus",
                            });
                            self.loadKategori();
                            self.isLoading = false;
                        })
                        .catch(function (error) {
                            self.requestFailed(error);
                            self.isLoading = false;
                        });
                }
            });
        },

        requestFailed(error) {
            let message = "Terjadi kesalahan pada sistem";

            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                message = error.response.data.message;
            }

            Toast.fire({
                icon: "error",
                title: message,
            });
        },
    },
};
</script>
